import { render, staticRenderFns } from "./file-icon.vue?vue&type=template&id=073f7892&scoped=true"
import script from "./file-icon.vue?vue&type=script&lang=js"
export * from "./file-icon.vue?vue&type=script&lang=js"
import style0 from "./file-icon.vue?vue&type=style&index=0&id=073f7892&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073f7892",
  null
  
)

export default component.exports